import AjaxButton from "../../../form/ajax_button";
import classNames from "classnames";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {updateDirectMessagingEnabled} from "virtual_congress/exhibition_actions";
import {ChatPreview} from "./chat_preview";
import {useChats} from "./utils";

export default function EnableDirectMessagingPrompt({setSearchResults, translations}) {
  const dispatch = useDispatch()
  const [enableDirectMessageCheckboxChecked, setEnableDirectMessageCheckboxChecked] = useState(false);
  const directMessageEnableInfoTextHtml = useSelector((state) => state.directMessaging?.directMessageEnableInfoTextHtml)
  const directMessageEnableCheckboxLabelHtml = useSelector((state) => state.directMessaging?.directMessageEnableCheckboxLabelHtml)
  const enableDirectMessagesUrl = useSelector((state) => state.directMessaging?.enableDirectMessagesUrl)
  const chats = useChats()

  return <>
    <div className="row">
      <div className="col">
        <div dangerouslySetInnerHTML={{__html: directMessageEnableInfoTextHtml}}/>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <div className="form-check">
          <input className="form-check-input" type="checkbox" value="" id="defaultCheck1" onChange={(event) => {
            setEnableDirectMessageCheckboxChecked(event.target.checked)
          }}/>
          <label className="form-check-label" htmlFor="defaultCheck1">
            <div dangerouslySetInnerHTML={{__html: directMessageEnableCheckboxLabelHtml}}/>
          </label>
        </div>
      </div>
    </div>
    {enableDirectMessageCheckboxChecked && <div className="row">
      <div className="col-12 text-center">
        <AjaxButton
          method="post"
          labelSending={translations.activeateDirectMessagingSendingButtonText || "ACTIVATING ..."}
          className={classNames("btn btn-outline-success btn-ueg btn-ueg-styled m-5")}
          icon="fa-check"
          url={enableDirectMessagesUrl}
          data={{}}
          label={translations.activeateDirectMessagingButtonText || "ACTIVATE DIRECT MESSAGING"}
          onSuccess={(data) => {
            if (data.data.status === "OK") {
              dispatch(updateDirectMessagingEnabled(data.data.isDirectMessagingEnabled))
            } else {
              alert(data.data.message || "An error occurred")
            }
          }}
          onError={(error) => {
            console.log(error)
            alert("An error occurred.", error)
          }}
        />
      </div>
    </div>}
    <div className="row limited-height-container">
      <div className="col-12">
        <hr/>
        {chats && chats.length > 0 && chats.map((chat) => {
          return <ChatPreview key={chat.tagOwner.id}
                              chat={chat}
                              setSearchResults={setSearchResults}
                              translations={translations} />
        })}
      </div>
    </div>
  </>
}